/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantThreeYearOld } from './InfantThreeYearOld';
import {
    InfantThreeYearOldFromJSON,
    InfantThreeYearOldFromJSONTyped,
    InfantThreeYearOldToJSON,
} from './InfantThreeYearOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantThreeYearOldPagination
 */
export interface InfantThreeYearOldPagination {
    /**
     * 
     * @type {Array<InfantThreeYearOld>}
     * @memberof InfantThreeYearOldPagination
     */
    data?: Array<InfantThreeYearOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantThreeYearOldPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantThreeYearOldPagination interface.
 */
export function instanceOfInfantThreeYearOldPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantThreeYearOldPaginationFromJSON(json: any): InfantThreeYearOldPagination {
    return InfantThreeYearOldPaginationFromJSONTyped(json, false);
}

export function InfantThreeYearOldPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantThreeYearOldPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantThreeYearOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantThreeYearOldPaginationToJSON(value?: InfantThreeYearOldPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantThreeYearOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

